module.exports = __webpack_public_path__ + "static/logo-lastfarm-ff8e482fa74eb06df2cb72e00569c1ac.svg";